// utils.js
export function verifyFields (data, validation) {
  return (data.model.length === 0 && validation === false && data.required)
}

export function persistToNewProviderStorage (inputValue, inputName) {
  let newProvider = JSON.parse(localStorage.getItem('newProviderPeru'))
  if (!newProvider) {
    newProvider = {}
  }
  newProvider[inputName] = inputValue
  localStorage.setItem('newProviderPeru', JSON.stringify(newProvider))
  //
  // localStorage.setItem(`${inputName}key`, JSON.stringify(inputValue))
}

export function saveDataToLocalStorage (inputValue, inputName) {
  persistToNewProviderStorage(inputValue, inputName)
}



// WEBPACK FOOTER //
// ./src/components/helpers/utils.js